import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import SchoolCodeEntry from './components/SchoolCodeEntry';
import GateList from './components/GateList';
import TVDisplay from './components/TVDisplay';
import { ErrorBoundary } from '@uniqcamp/shared';
import { exitFullscreen } from './utils/fullscreen';

function App() {
  const [schoolCode, setSchoolCode] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return p.get('code')?.trim().toUpperCase() || '';
  });
  const [gateId, setGateId] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return p.get('gate')?.trim() || '';
  });
  const [otp, setOtp] = useState('');

  const updateUrl = (code: string, gate: string) => {
    const params = new URLSearchParams();
    if (code) params.set('code', code);
    if (gate) params.set('gate', gate);
    const qs = params.toString();
    const newUrl = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
    window.history.replaceState(null, '', newUrl);
  };

  const handleSchoolSuccess = (code: string, otpValue: string) => {
    setSchoolCode(code);
    setOtp(otpValue);
    setGateId('');
    updateUrl(code, '');
  };

  const handleSelectGate = (gId: string) => {
    setGateId(gId);
    updateUrl(schoolCode, gId);
  };

  const handleBackToGates = () => {
    setGateId('');
    updateUrl(schoolCode, '');
  };

  const handleBackToSchool = () => {
    setSchoolCode('');
    setGateId('');
    setOtp('');
    updateUrl('', '');
  };

  const handleOtpInvalid = () => {
    exitFullscreen();
    alert('The display OTP has been changed by the school principal. Please enter the new OTP to continue.');
    setSchoolCode('');
    setGateId('');
    setOtp('');
    updateUrl('', '');
  };

  return (
    <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!schoolCode && <SchoolCodeEntry onSuccess={handleSchoolSuccess} />}
      {schoolCode && !gateId && (
        <GateList
          schoolCode={schoolCode}
          otp={otp}
          onSelectGate={handleSelectGate}
          onBack={handleBackToSchool}
        />
      )}
      {schoolCode && gateId && (
        <TVDisplay
          schoolCode={schoolCode}
          gateId={gateId}
          otp={otp}
          onBackToGates={handleBackToGates}
          onOtpInvalid={handleOtpInvalid}
        />
      )}
    </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
